var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('MainLogo'),(_vm.$country === 'ru')?_c('RuLogos'):(_vm.$country === 'kz')?_c('KzLogos'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }